import { createLabeledMessages } from '../../../messageUtils';
const help = {
    onlineChat: 'Online chat',
    shareScreen: 'Share screen',
    help: 'Help',
    dialogTitle: 'Start screen sharing',
    dialogEndRelation: 'End session',
    dialogNeedHelp: 'Need help with screen sharing?',
    dialogContact: 'Contact us by phone on the support line',
    dialogShareToOperator: 'Tell the operator generated PIN'
};
const messages = Object.assign({}, help);
export default Object.assign({}, messages, createLabeledMessages(messages));
